<script setup lang="ts">
const containerRef = ref<HTMLElement | null>(null);

onMounted(() => {
  document.addEventListener('mousemove', (e: MouseEvent) => {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const diffX = e.clientX - centerX;
    const diffY = e.clientY - centerY;

    containerRef.value?.style.setProperty('--diff-x', `${diffX}px`);

    containerRef.value?.style.setProperty('--diff-y', `${diffY}px`);
  });
});
</script>

<template>
  <div ref="containerRef" class="blobs-container _hidden-vs">
    <div class="inner">
      <div class="blob orange" />
      <div class="blob pink" />
      <div class="blob green" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.blobs-container {
  position: fixed;
  inset: 0;
  display: flex;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;

  .inner {
    position: absolute;
    overflow: visible;
    transition: transform 2.5s ease-out;
    left: calc(50% - 25vw);
    top: calc(50% - 25vw);

    width: 50vw;
    height: 50vw;
    transform: translate(var(--diff-x, 0), var(--diff-y, 0));
  }

  .blob {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);

    &.orange {
      left: -33%;
      top: 0%;
      background: radial-gradient(
        circle,
        rgba(252, 206, 136, 0.8) 0%,
        rgba(252, 206, 136, 0) 67%
      );
      transform: translate(var(--diff-x, 0), var(--diff-y, 0));
      transition: transform 3s ease-out;
      transition-delay: 300ms;
    }

    &.pink {
      left: 0%;
      top: 10%;
      background: radial-gradient(
        circle,
        rgba(232, 149, 255, 0.8) 0%,
        rgba(232, 149, 255, 0) 67%
      );
    }

    &.green {
      left: 45%;
      top: 12%;
      background: radial-gradient(
        circle,
        rgba(0, 253, 238, 0.8) 0%,
        rgba(0, 253, 238, 0) 67%
      );
      transform: translate(var(--diff-x, 0), var(--diff-y, 0));
      transition: transform 3.2s ease-out;
      transition-delay: 600ms;
    }
  }
}
</style>
